<template>
  <div
    class="time-tracking__customer hover-highlight q-py-xs q-px-sm row items-center no-wrap"
    :class="{ 'bg-grey-2': active, 'cursor-pointer': clickable }"
    @click="$emit('click', $event)"
  >
    <q-icon v-if="!hideIcon" :name="icon" color="grey-6"/>
    <span class="q-subheading text-faded block ellipsis" :class="{ 'on-right': !hideIcon }">{{ customerName }}</span>
  </div>
</template>

<script>
  import { getCustomerName } from 'src/utils/searchResultParser'
  import i18n from 'src/i18n/i18n'

  export default {
    props: {
      customer: {
        required: true,
        type: Object,
        default: () => ({
          'type': 'company',
          'name': i18n.t('without_customer')
        })
      },

      active: {
        type: Boolean,
        default: false
      },

      clickable: {
        type: Boolean,
        default: false
      },

      hideIcon: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      customerName () {
        return getCustomerName(this.customer)
      },

      icon () {
        return this.customer.type === 'company' ? 'business' : 'person'
      }
    }
  }
</script>

<style lang="stylus">
  @import '~variables'

  .time-tracking
    &__customer
      border-radius: 15px
</style>
